import { useRef, useState } from "react";
const useSearchTerm = ({ initialSearchTerm = '' })=>{
    const [searchTerm, setSearchTerm] = useState({
        value: initialSearchTerm,
        cleanValue: initialSearchTerm,
        evaluatedValue: initialSearchTerm,
        isValid: initialSearchTerm.trim().length > 1
    });
    const textFieldRef = useRef(null);
    const focusTextField = ()=>{
        if (textFieldRef.current) textFieldRef.current.focus();
    };
    const blurTextField = ()=>{
        if (textFieldRef.current) textFieldRef.current.blur();
    };
    const onSearchTermChange = (value)=>{
        const cleanValue = value.trim();
        setSearchTerm((prevState)=>({
                ...prevState,
                value,
                cleanValue,
                isValid: cleanValue.length > 1
            }));
    };
    const onEvaluatedSearchTermChange = (evaluatedValue)=>{
        setSearchTerm((prevState)=>({
                ...prevState,
                evaluatedValue
            }));
    };
    return {
        searchTerm,
        onSearchTermChange,
        onEvaluatedSearchTermChange,
        searchTextField: {
            ref: textFieldRef,
            focus: focusTextField,
            blur: blurTextField
        }
    };
};
const hooks_useSearchTerm = useSearchTerm;
export default hooks_useSearchTerm;
